import React from "react";
import { Chip } from "@mui/material";

import {
  ClientLinkRequestStatus,
  ClientLinkRequestStatusType
} from "../../../interfaces/ClientLinkRequests";

type ChipColor = "success" | "error" | "warning";

const getColor = (status: ClientLinkRequestStatusType): { color: ChipColor; label: string } => {
  switch (status) {
    case ClientLinkRequestStatus.APPROVED:
      return { color: "success", label: ClientLinkRequestStatus.APPROVED };
    case ClientLinkRequestStatus.REJECTED:
      return { color: "error", label: ClientLinkRequestStatus.REJECTED };
    case ClientLinkRequestStatus.PENDING:
    default:
      return { color: "warning", label: ClientLinkRequestStatus.PENDING };
  }
};

// eslint-disable-next-line import/prefer-default-export
export const ClientLinkRequestStatusChip = ({
  status
}: {
  status: ClientLinkRequestStatusType;
}): React.ReactNode => {
  const { color, label } = getColor(status);

  return (
    <Chip
      label={label}
      variant="filled"
      size="small"
      sx={{
        textTransform: "capitalize",
        bgcolor: `${color}.main`,
        color: "white"
      }}
    />
  );
};
